import React from 'react';
import PropTypes from 'prop-types';
import { Outlet, Navigate } from 'react-router-dom';
import useAuthHook, { userRoleEnums } from '../hooks/custom-hooks/useAuthHook';

function PermissionRoute(props) {
  const { allowedRoles } = props;
  const { isCustomerAdmin } = useAuthHook();

  // Added condition for customer admin not access the route
  if (isCustomerAdmin && !allowedRoles?.includes(userRoleEnums.CUSTOMER_ADMIN)) {
    return <Navigate to='/' />;
  }

  return <Outlet />;
}

PermissionRoute.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.oneOfType(PropTypes.string, PropTypes.number)),
};

PermissionRoute.defaultProps = {
  allowedRoles: undefined,
};

export default React.memo(PermissionRoute);
